import { render, staticRenderFns } from "./IpWhitelist.vue?vue&type=template&id=53e88ef2&scoped=true"
import script from "./IpWhitelist.vue?vue&type=script&lang=js"
export * from "./IpWhitelist.vue?vue&type=script&lang=js"
import style0 from "./IpWhitelist.vue?vue&type=style&index=0&id=53e88ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e88ef2",
  null
  
)

export default component.exports